// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageFileContent_content__wAMOk {
  padding: 8px;
  width: 100%;
  display: flex;
  position: relative;
}

.MessageFileContent_file__Clttw {
  cursor: pointer !important;
  flex-shrink: 1;
  min-width: 1px;
  overflow: hidden;
}

.MessageFileContent_attributes__3mnjd {
  position: absolute;
  bottom: 5px;
  right: 7px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MessageGroup/Content/MessageFileContent/MessageFileContent.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EAEA,kBAAA;AAAF;;AAGA;EACE,0BAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAAF","sourcesContent":[".content {\n  padding: 8px;\n  width: 100%;\n  display: flex;\n\n  position: relative;\n}\n\n.file {\n  cursor: pointer !important;\n  flex-shrink: 1;\n  min-width: 1px;\n  overflow: hidden;\n}\n\n.attributes {\n  position: absolute;\n  bottom: 5px;\n  right: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `MessageFileContent_content__wAMOk`,
	"file": `MessageFileContent_file__Clttw`,
	"attributes": `MessageFileContent_attributes__3mnjd`
};
export default ___CSS_LOADER_EXPORT___;
